import { redirectToLogin } from "./annoucement-sheet";
import { api, getLanguageCode, getLanguageCodeForbackend } from "./api";
import authHeader from "./auth-header";
export type DropdownDataWithLanguage = {
    id: number;
    name_en: string;
    name_tc: string;
    name_sc: string;
  };
  type EventsResponse = {
    module_id: number;
    status: boolean;
    data: TData;
  };
  
  export type TData = {
    data: DepartmentInfo[];
    total: number;
  };
  export type DepartmentInfo = {
    id?: number;
    name: string;
  };
  export type eventInfo = {
    month: number;
    year: number;
  };

export const eventRemainderApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEventRemainder: build.query<EventsResponse, eventInfo>({
      query: ({month,year}) => ({
        url: `${getLanguageCodeForbackend()}eventsLists?month=${month}&year=${year}`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
  }),
});

export const {
    useGetEventRemainderQuery
} = eventRemainderApi;

export const {
  endpoints: {
    getEventRemainder
  },
} = eventRemainderApi;
